import React from 'react';
import { StandardDeviationElementPlacement } from './types';
import { useStandardDeviationElementPlacementMap } from './useStandardDeviationElementPlacementMap';
export const StandardDeviationElementPlacementContext = /*#__PURE__*/ React.createContext({
    elementGroups: {
        adoptableBuyer: {
            groupPlacement: StandardDeviationElementPlacement.NotIncluded,
            countOnBar: 0
        },
        adoptableSeller: {
            groupPlacement: StandardDeviationElementPlacement.NotIncluded,
            countOnBar: 0
        }
    },
    deleteDeviation: StandardDeviationElementPlacement.NotIncluded,
    editBackground: StandardDeviationElementPlacement.NotIncluded,
    editDeviation: StandardDeviationElementPlacement.NotIncluded,
    favourite: StandardDeviationElementPlacement.NotIncluded,
    fullscreen: StandardDeviationElementPlacement.NotIncluded,
    report: StandardDeviationElementPlacement.NotIncluded,
    share: StandardDeviationElementPlacement.NotIncluded,
    subscribe: StandardDeviationElementPlacement.NotIncluded,
    comment: StandardDeviationElementPlacement.NotIncluded,
    commissionStatus: StandardDeviationElementPlacement.NotIncluded,
    orderCommission: StandardDeviationElementPlacement.NotIncluded,
    premiumDownload: StandardDeviationElementPlacement.NotIncluded,
    freeDownload: StandardDeviationElementPlacement.NotIncluded,
    addToGroup: StandardDeviationElementPlacement.NotIncluded,
    awardBadge: StandardDeviationElementPlacement.NotIncluded,
    boostDeviation: StandardDeviationElementPlacement.NotIncluded,
    sellDeviation: StandardDeviationElementPlacement.NotIncluded,
    privateCollection: StandardDeviationElementPlacement.NotIncluded,
    viewOrderHistory: StandardDeviationElementPlacement.NotIncluded,
    unpublish: StandardDeviationElementPlacement.NotIncluded,
    meta: {
        hasPrimaryMoreActionsMenu: false,
        hasSecondaryMoreActionsMenu: false
    }
});
export const StandardDeviationElementPlacementContextProvider = ({ deviation, children })=>{
    const elementPlacementMap = useStandardDeviationElementPlacementMap(deviation);
    return /*#__PURE__*/ React.createElement(StandardDeviationElementPlacementContext.Provider, {
        value: elementPlacementMap
    }, children);
};
StandardDeviationElementPlacementContextProvider.displayName = 'StandardDeviationElementPlacementContextProvider';

//# sourceMappingURL=context.js.map